import { initialSysStoresState, actions } from "./action";

export const sysStoreReducer = (state = initialSysStoresState, action) => {
    switch (action.type) {
        case actions.SYSSTORE_GET_ALL_SUCCESS:

            
            const countryValueTemplate = code => {
                const country = state?.countriesList?.find(country => country.code === code);
                return country ? `${country.code} - ${country.name}` : code;
            };
            const updatedData = action.payload?.data?.map(store => ({
                ...store,
                country: countryValueTemplate(store.country)
            })) || [];
            return { ...state, sysstoreList: { ...action.payload, data: updatedData }
        };
        case actions.SYSSTORE_UPDATE_SUCCESS:
            return {
                ...state,
                sysstore: action.payload?.id ? {...action.payload, action: 'update'} : {}
            };
        case actions.SYSSTORE_CREATE_SUCCESS:
            return {
                ...state,
                sysstore: action.payload?.id ? {...action.payload, action: 'create'} : {}
            };
        case actions.SYSSTORE_DELETE_SUCCESS:
            return {
                ...state,
                sysstore: action.payload?.id ? {...action.payload, action: 'delete'} : {}
            };
        case actions.SYSSTORE_SYNC_STORES_SUCCESS:
            return {
                ...state,
                sysstoreSynced:  action?.payload?.synced
            };
        case actions.SYSSTORE_RESET_SUCCESS:
            return {
                ...state,
                sysstore: {},
                filters: {}
            };
        case actions.SYSSTORE_SET_FILTERS_REQUEST:
            return {
                ...state,
                filters: action.payload
            };
        case actions.SYSSTORE_GET_ALL_COUNTRIES_SUCCESS:
            return {
                ...state,
                countriesList: action.payload ? action.payload : {}
            };
        default:
            return state;
    }
};
